var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.568 36.878A4.878 4.878 0 0 1 56.446 32h72.474a4.878 4.878 0 1 1 0 9.756h-15.331a4.878 4.878 0 1 0 0 9.756h35.54a6.272 6.272 0 1 1 0 12.544H39.721a6.272 6.272 0 1 1 0-12.544h29.965a4.867 4.867 0 0 1-1.742-.32 4.88 4.88 0 0 0 0-9.116 4.867 4.867 0 0 1 1.742-.32h-13.24a4.878 4.878 0 0 1-4.878-4.878Zm106.62 20.906a6.272 6.272 0 0 1 6.272-6.272h12.543a6.272 6.272 0 1 1 0 12.544H164.46a6.272 6.272 0 0 1-6.272-6.272ZM39.721 73.812a6.272 6.272 0 1 0 0 12.543h85.715a6.272 6.272 0 0 0 0-12.543H39.721ZM6.969 101.338a5.226 5.226 0 0 1 5.226-5.226h42.509a5.226 5.226 0 1 1 0 10.452h-2.09a5.227 5.227 0 0 0 0 10.453h33.449a5.226 5.226 0 1 1 0-10.453h78.745a5.227 5.227 0 1 1 0 10.453h-14.285a5.227 5.227 0 1 0 0 10.453h8.014a5.227 5.227 0 0 1 0 10.453h-32.056a5.227 5.227 0 0 1 0 10.453H85.366a5.227 5.227 0 0 0 0 10.453h6.272a5.227 5.227 0 0 1 0 10.453H48.432a5.226 5.226 0 1 1 0-10.453h.697a5.226 5.226 0 1 0 0-10.453H5.226a5.226 5.226 0 1 1 0-10.453h20.906a5.226 5.226 0 1 1 0-10.453h1.046a5.226 5.226 0 1 0 0-10.453h-2.44a5.226 5.226 0 1 1 0-10.453H12.196a5.226 5.226 0 0 1-5.226-5.226Zm174.564 5.226a5.227 5.227 0 0 0 0 10.453h13.241a5.226 5.226 0 0 0 0-10.453h-13.241Z",
    fill: "#F6F8FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.345 150.467a4.181 4.181 0 0 0 0 8.362h9.059a4.181 4.181 0 0 0 0-8.362h-9.059Z",
    fill: "#F6F8FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.121 35.53a2.062 2.062 0 1 1 0 4.124H40.748a2.062 2.062 0 0 1 0-4.124H53.12Zm-22.685 0a2.062 2.062 0 1 1 0 4.124H18.062a2.062 2.062 0 0 1 0-4.124h12.374Zm7.218 19.591a2.062 2.062 0 1 1-4.124 0V42.748a2.062 2.062 0 0 1 4.124 0V55.12Zm0-22.685a2.062 2.062 0 0 1-4.124 0V20.062a2.062 2.062 0 0 1 4.124 0v12.374Zm148.742 88.876a1.088 1.088 0 1 1 1.539 1.539l-4.618 4.618a1.088 1.088 0 1 1-1.539-1.54l4.618-4.617Zm-8.466 8.466a1.088 1.088 0 1 1 1.539 1.539l-4.618 4.618a1.088 1.088 0 1 1-1.539-1.54l4.618-4.617Zm10.005 4.617a1.09 1.09 0 0 1-1.539 1.54l-4.618-4.618a1.088 1.088 0 1 1 1.539-1.539l4.618 4.617Zm-8.466-8.466a1.09 1.09 0 0 1-1.539 1.54l-4.618-4.618a1.088 1.088 0 1 1 1.539-1.539l4.618 4.617ZM25.252 105.088a1.088 1.088 0 0 1 2.177 0v6.531a1.088 1.088 0 0 1-2.177 0v-6.531Zm0 11.973a1.088 1.088 0 0 1 2.177 0v6.531a1.088 1.088 0 0 1-2.177 0v-6.531Zm10.34-3.809a1.088 1.088 0 1 1 0 2.177h-6.53a1.089 1.089 0 0 1 0-2.177h6.53Zm-11.972 0a1.088 1.088 0 1 1 0 2.177h-6.532a1.089 1.089 0 0 1 0-2.177h6.531Z",
    fill: "#D4DDEC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.354,
    cy: 104.354,
    fill: "#EEF2F5",
    r: 4.354
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.354,
    cy: 168.354,
    fill: "#EEF2F5",
    r: 4.354
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.884 181.048a8.164 8.164 0 1 0 0-16.328 8.164 8.164 0 0 0 0 16.328Zm0 2.721c6.012 0 10.885-4.873 10.885-10.885 0-6.011-4.873-10.884-10.885-10.884-6.011 0-10.884 4.873-10.884 10.884 0 6.012 4.873 10.885 10.884 10.885Zm-60-148.721a8.163 8.163 0 1 0 0-16.327 8.163 8.163 0 0 0 0 16.327Zm0 2.72c6.012 0 10.885-4.872 10.885-10.884 0-6.01-4.873-10.884-10.885-10.884C82.874 16 78 20.873 78 26.884c0 6.012 4.873 10.885 10.884 10.885Z",
    fill: "#D4DDEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.072 31c-2.858 0-5.17 2.373-5.17 5.306v48.969c0 3.845-3.04 6.953-6.776 6.953h-33.677v-54.66c0-3.624 2.869-6.568 6.401-6.568h39.222Z",
    fill: "url(#a)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.126 92.228h-17.117V62.724c0-2.933 2.312-5.306 5.17-5.306a5.09 5.09 0 0 1 3.651 1.549 5.36 5.36 0 0 1 1.509 3.746v22.551c0 3.845 3.04 6.964 6.787 6.964Z",
    fill: "url(#b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.18 57.429c-2.858 0-5.17 2.373-5.17 5.306v98.696c0 1.813-.717 3.46-1.874 4.647a6.31 6.31 0 0 1-4.528 1.922H65.896c-3.532 0-6.401-2.944-6.401-6.569V63.998c0-3.625 2.869-6.569 6.401-6.569h61.284Z",
    fill: "url(#c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.608 167.989H51.402c-3.533 0-6.402-2.944-6.402-6.568v-4.032h64.207v4.032c0 3.635 2.869 6.568 6.401 6.568Z",
    fill: "url(#d)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.034 155.53a3.235 3.235 0 0 1-4.661 0l-19.991-20.528-2.548-2.614a16.66 16.66 0 0 0 4.662-4.784l22.538 23.128c1.288 1.337 1.288 3.476 0 4.798Z",
    fill: "#8C90A5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m131.51 128.659 5.211 5.348a16.661 16.661 0 0 1-4.661 4.783l-2.663-2.733-2.548-2.615a16.636 16.636 0 0 0 4.661-4.783Z",
    fill: "#71768A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.707 117.518a21.278 21.278 0 0 0-.261-2.555 20.54 20.54 0 0 0-6.557-11.957C126.4 99.886 121.84 98 116.861 98c-10.973 0-19.86 9.12-19.86 20.395 0 .772.043 1.545.13 2.302a20.54 20.54 0 0 0 1.896 6.67 20.424 20.424 0 0 0 6.065 7.441c.42.312.84.609 1.288.892a19.416 19.416 0 0 0 10.495 3.075c4.299 0 8.28-1.397 11.523-3.773a20.42 20.42 0 0 0 7.57-10.963 20.72 20.72 0 0 0 .768-5.644c-.015-.297-.029-.58-.029-.877Zm-19.861 17.632a15.934 15.934 0 0 1-9.568-3.179 16.818 16.818 0 0 1-5.776-7.813 17.272 17.272 0 0 1-.999-5.778c0-.758.044-1.515.145-2.258.811-6.209 4.951-11.348 10.509-13.473a16.004 16.004 0 0 1 5.675-1.039c.723 0 1.433.044 2.128.148a16.019 16.019 0 0 1 8.685 4.07 16.954 16.954 0 0 1 5.515 12.552c0 .252 0 .505-.014.757a17.217 17.217 0 0 1-.536 3.58 17.105 17.105 0 0 1-2.142 4.887 16.64 16.64 0 0 1-4.662 4.783c-.448.312-.926.594-1.404.847a15.556 15.556 0 0 1-3.286 1.322c-1.346.401-2.779.594-4.27.594Z",
    fill: "#A2A6B8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.484 120.237c-.839 0-1.52-.699-1.52-1.56 0-3.877 1.477-7.531 4.155-10.279s6.239-4.263 10.017-4.263c.839 0 1.52.698 1.52 1.559 0 .862-.681 1.56-1.52 1.56-2.968 0-5.762 1.188-7.86 3.342-2.099 2.154-3.257 5.021-3.257 8.066-.015.876-.695 1.575-1.535 1.575Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.853 35.158a4.158 4.158 0 1 1 8.316 0v4.158h-8.316v-4.158Z",
    fill: "#AAB0C7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 128.261,
    y1: 31,
    x2: 128.261,
    y2: 92.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 130.567,
    y1: 57.418,
    x2: 130.567,
    y2: 92.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BA1B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 93.337,
    y1: 57.429,
    x2: 93.337,
    y2: 168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE0EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 80.304,
    y1: 157.389,
    x2: 80.304,
    y2: 167.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC3D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969CB4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultIcon);
export default __webpack_public_path__ + "static/media/no-result-icon.439bd1a7c8009858fe60ca24938bcbea.svg";
export { ForwardRef as ReactComponent };